import { render, staticRenderFns } from "./editPerson.vue?vue&type=template&id=03cb8609&scoped=true"
import script from "./editPerson.vue?vue&type=script&lang=js"
export * from "./editPerson.vue?vue&type=script&lang=js"
import style0 from "./editPerson.vue?vue&type=style&index=0&id=03cb8609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb8609",
  null
  
)

export default component.exports